export enum TOKEN_STANDARDS {
  ERC20 = "ERC-20",
  ERC721 = "ERC-721",
  ERC1155 = "ERC-1155",
}
